module.exports = __webpack_public_path__ + "assets/img/weixin.3d026033.png";